var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNote(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.118,
    height: 24.8,
    viewBox: "0 0 18.118 24.8",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2428",
    "data-name": "Group 2428",
    transform: "translate(0.5 0.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5012",
    "data-name": "Path 5012",
    d: "M1354.794,1514.613V1509.7H1349.9Z",
    transform: "translate(-1340.113 -1508.521)",
    fill: "#ffc124"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5013",
    "data-name": "Path 5013",
    d: "M1300.1,1586.8v4.913h4.913Z",
    transform: "translate(-1300.1 -1570.469)",
    fill: "#ffc124"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1740",
    "data-name": "Group 1740",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5014",
    "data-name": "Path 5014",
    d: "M1310.379,1529.884H1300.1V1509.7h4.913",
    transform: "translate(-1300.1 -1508.521)",
    fill: "none",
    stroke: "#6c5b7b",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5015",
    "data-name": "Path 5015",
    d: "M1349.9,1509.7h4.894v15.781",
    transform: "translate(-1340.113 -1508.521)",
    fill: "none",
    stroke: "#6c5b7b",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1738",
    "data-name": "Group 1738",
    transform: "translate(3.321 7.114)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_1357",
    "data-name": "Line 1357",
    x2: 8.038,
    fill: "none",
    stroke: "#6c5b7b",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1358",
    "data-name": "Line 1358",
    x2: 8.038,
    transform: "translate(0 2.771)",
    fill: "none",
    stroke: "#6c5b7b",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1359",
    "data-name": "Line 1359",
    x2: 8.038,
    transform: "translate(0 5.542)",
    fill: "none",
    stroke: "#6c5b7b",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1360",
    "data-name": "Line 1360",
    x2: 8.038,
    transform: "translate(0 8.333)",
    fill: "none",
    stroke: "#6c5b7b",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_5016",
    "data-name": "Path 5016",
    d: "M1325.1,1504.034v2.516a.436.436,0,0,0,.432.432h.177a.442.442,0,0,0,.432-.374v-.059a1.507,1.507,0,0,1,1.494-1.317h0a1.5,1.5,0,0,1,1.494,1.317v.059a.427.427,0,0,0,.432.374h0a.436.436,0,0,0,.432-.432v-2.516a.344.344,0,0,0-.334-.334h-4.206A.336.336,0,0,0,1325.1,1504.034Z",
    transform: "translate(-1320.187 -1503.7)",
    fill: "none",
    stroke: "#6c5b7b",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_256",
    "data-name": "Ellipse 256",
    cx: 3.498,
    cy: 3.498,
    rx: 3.498,
    ry: 3.498,
    transform: "translate(10.121 16.803)",
    fill: "none",
    stroke: "#6c5b7b",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1739",
    "data-name": "Group 1739",
    transform: "translate(12.087 19.044)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5017",
    "data-name": "Path 5017",
    d: "M1361.6,1601.838l1.415,1.258,2.044-2.5",
    transform: "translate(-1361.6 -1600.6)",
    fill: "none",
    stroke: "#6c5b7b",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNote);
export default __webpack_public_path__ + "static/media/Note.bf5678c357bc33243577c5184a96f64d.svg";
export { ForwardRef as ReactComponent };